import { getLocalizedString } from "./getLocalizedString.js";
import { invariant } from "./invariant.js";

/**
 * Localization function for tagged templates. Replaces the arguments
 * with $n, where n is the index, before asking Appframe to translate
 * the string.
 *
 * For example, if you call localize`Page ${2} or ${5}`, the string
 * "Page $0 of $1" will be sent to Appframe, and for norwegian,
 * "Side 2 av 5" will be returned.
 *
 * @param stringParts
 * @param args
 * @returns Translated string
 */
export function localize(stringParts: TemplateStringsArray, ...args: any[]): string {
	invariant(
		Array.isArray(stringParts) && stringParts.length === args.length + 1,
		"Method 'localize' must be used as a tag function",
	);

	let stringToLocalize = stringParts.map((s, i) => (i === stringParts.length - 1 ? s : `${s}\$${i}`)).join("");
	let localized = getLocalizedString(stringToLocalize);

	args.forEach((arg, index) => {
		localized = localized.replace("$" + index, arg);
	});

	return localized;
}
